import React, { useEffect, useRef, useState } from 'react';
import styles from './aboutusSec.module.css';
import { accord } from '../../../constants';
import { floatImg2 } from '../../../assets';
import Accordion from '../accordion/Accordion';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import useTextAnimation from '../../hooks/useTextAnimation';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHowWeDoData } from '../../slice/howWeDoSlice';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_AR, LANG_EN } from '../../helpers/constant';

gsap.registerPlugin(ScrollTrigger);

const AboutAccordion = ({ howWeDoData }) => {
    const [openIndex, setOpenIndex] = useState(null);
    const section1Ref = useRef(null);
    const [howWeDo, setHowWeDo] = useState([]);

    const { t, i18n } = useTranslation();

    const handleAccordionClick = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    /*  const dispatch = useDispatch();
     const {data : howWeDoData, loading, error} = useSelector((state) => state.howWeDo);
     useEffect(() => {
         dispatch(fetchHowWeDoData());
     },[dispatch]);
 
     useEffect(() => {
         console.log('How We Do Data : ', howWeDoData);
 
 
 
           setHowWeDo(howWeDoData)
     },[howWeDoData]); */

    useEffect(() => {
        const ctx = gsap.context(() => {
            gsap.from(`.${styles._accordionTitle} h3`, {
                opacity: 0,
                y: 50,
                duration: 1,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: `.${styles._accordionTitle}`,
                    start: 'top 90%',
                    scrub: false,
                },
            });
        }, section1Ref);

        return () => ctx.revert();
    }, []);

    const { ref: abtBTRef, inView: abtBTInView, textAnimation } = useTextAnimation();

    const colorPalette = ['#DD043E', '#3e5beb', '#CE1974', '#6652C4'];

    return (
        <div className={`${styles._accordion}`}>
            <div className={styles._accordionWrapper} ref={section1Ref}>
                <div className={`${styles._accordionTitle} ${i18n.language === LANG_AR ? 'arabText' : ''} `}>
                    <motion.h3
                        ref={abtBTRef}
                        initial="hidden"
                        animate={abtBTInView ? 'visible' : 'hidden'}
                        custom={0}
                        variants={textAnimation}
                    >
                        {t('aboutHowWeDo')}
                    </motion.h3>
                </div>
                <span className={`${styles._accordionFloatImg} ${i18n.language === LANG_AR ? 'arabLogo' : ''}`}>
                    <img src={floatImg2} alt="" />
                </span>
                <ul className={`${styles._accordionLst} `}>
                    {howWeDoData.length > 0 && howWeDoData.map((faq, index) => (
                        <li key={faq._id}>
                            <div className={`${styles._accordionLnk} ${i18n.language === LANG_AR ? 'arabText' : ''}`}>
                                <Accordion
                                    /*  question={faq.question}
                                     answer={faq.answer} */

                                    question={i18n.language === LANG_EN ? faq.question : faq.questionAr}
                                    answer={i18n.language === LANG_EN ? faq.answer : faq.answerAr}


                                    isOpen={openIndex === index}
                                    onClick={() => handleAccordionClick(index)}
                                    colorStartIndex={index % colorPalette.length}
                                    colorPalette={colorPalette}
                                />
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default AboutAccordion;
